import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import env from "react-dotenv";
import { Header } from '../components/Header';

function Profile() {
    let navigate = useNavigate();


    useEffect(() => {
        const fetchEmail = async () => {
            const res = await fetch(env.BACKEND_URL + "/admin/email", {
                method: "GET",
                credentials: 'include'
            });

            if (res.ok) {
                const data = await res.json();
                setEmail(data.email);
            }
        }

        fetchEmail();
    }, [])

    const [email, setEmail] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    async function handleSubmit() {
        const res = await fetch(env.BACKEND_URL + "/admin/change-email", {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                username: email
            }),
            credentials: 'include'
        });

        if (res.ok)
            navigate("/main");
        else
            setErrorMessage("Erreur : " + await res.text());
    }

    function handleChangeEmail(event) {
        setEmail(event.target.value);
    }

    function handleChangePassword() {
        navigate("/change-password");
    }

    /*async function handleDisconnect() {
        const res = await fetch(env.BACKEND_URL + "/admin/logout", {
            method: "GET",
            credentials: "include"
        });

        if (res.ok)
            navigate("/");
    }*/

    return (
        <div>
            <Header navigate={navigate}></Header>
            
            <div className="login">
                <div className="big-title-login">
                    Informations de connexion
                </div>

                <div className="login-form">
                    <div className="login-error-text">
                        {errorMessage}
                    </div>

                    <div className="identifiants">
                        Identifiants
                    </div>
                    <div className="login-form-title">
                        E-MAIL
                    </div>
                    <input className="login-input-field" type="text" value={email} onChange={handleChangeEmail} />

                    <div className="login-form-title">
                        MOT DE PASSE
                    </div>
                    
                    <div className="flex">
                        <input className="login-input-field" type="password" disabled />
                        <button className="grey-button" onClick={handleChangePassword}>Modifier</button>
                    </div>
                    <div>
                        <button className="button" onClick={handleSubmit}>Enregistrer</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;